var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "demo" } }, [
    _c("div", { staticClass: "example-text" }, [
      _vm._v(
        "\n    Here is an example of a tooltip with absolute placement.\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "example" },
      [
        _c("tip", { attrs: { position: "auto-center" } }, [
          _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
          _vm._v(" "),
          _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
            _vm._v("\n        Some additional content! "),
            _c("strong", [_vm._v("HTML")]),
            _vm._v(" can be "),
            _c("i", [_vm._v("used")]),
            _vm._v(" here..\n      ")
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "example-text" }, [
      _vm._v("\n    Here is an example of a tooltip with fixed placement.\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "example" },
      [
        _c(
          "tip",
          { attrs: { fixed: true, position: "auto-center", width: 250 } },
          [
            _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
              _vm._v(
                "\n        I am fixed to the page. Useful when trying to display outside of a\n        container with complicated css scrolling or positioning.\n      "
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "example-text" }, [
      _vm._v("\n    These tooltips use an auto position.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "example-table" }, [
      _c("div", { staticClass: "example-row" }, [
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v(
                  "\n            This tooltip is on the right.\n          "
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v(
                  "\n            This tooltip is in the center.\n          "
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "example-cell" },
          [
            _c("tip", { attrs: { position: "auto-auto" } }, [
              _c("div", { staticClass: "trigger" }, [_vm._v("Hover")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "tip" }, slot: "tip" }, [
                _vm._v("\n            This tooltip is on the left.\n          ")
              ])
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34adf496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34adf496","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/Demo.vue
// module id = QIjP
// module chunks = 0